import { INavigationElement } from 'global';
import { useMemo } from 'react';
import { NAVIGATION_ELEMENT_CONFIGS, NavigationExperiments } from './data';
import { NavigationType, PetType, TargetGroup } from './utils';
import { processVariant } from './utils/experiment-helpers';

/**
 * Custom hook to process navigation elements with experiments
 */
export const useProcessedNavigationElements = (
  navigationElements: INavigationElement[] | undefined,
  experiments: NavigationExperiments
): INavigationElement[] | undefined => {
  return useMemo(() => {
    if (!navigationElements) return undefined;

    return navigationElements.map((element: INavigationElement) => {
      const type = element.fields?.type;
      const targetGroup = element.fields?.targetGroup;
      const petType = element.fields?.petType;

      // Find matching experiment configuration
      const config = NAVIGATION_ELEMENT_CONFIGS.find(
        (config) =>
          NavigationType[config.type] === type &&
          TargetGroup[config.targetGroup] === targetGroup &&
          PetType[config.petType] === petType
      );

      if (config) {
        const key = `${config.type}_${config.petType}_${config.targetGroup}`;
        const experimentData = experiments[key];

        if (experimentData?.experiment.variant) {
          const processedVariant = processVariant(
            experimentData.experiment.variant,
            element
          );
          if (processedVariant) {
            return processedVariant;
          }
        }
      }

      return element;
    });
  }, [navigationElements, experiments]);
};
